import styled from 'styled-components'
import { prop } from 'styled-tools'

const Link = styled.a`
  color: ${prop('color', prop('theme.typography.link.color'))};
  text-decoration: ${prop('theme.typography.link.textDecoration')};
`

export default Link
